import { useEffect, useState } from 'react';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import useDeviceTelemetry from './useDeviceTelemetry';

export default function useDeviceStats(activationId: number) {
    const [queueData, setQueueData] = useState<QueueData[] | null>(null);
    const [printRollup, setPrintRollup] = useState<{
        total: number;
        devices: { deviceKeyId: string; prints: number }[];
    }>({ total: 0, devices: [] });
    const {
        getQueueDataForActivation,
        getPrintRollupForActivation,
        isLoading,
        error,
    } = useDeviceTelemetry();
    const { orgId } = useUserOrg();

    interface QueueData {
        deviceKeyId: string;
        deviceId: string;
        queueData: Record<string, unknown>;
        updatedAt: string;
        name: string;
    }

    useEffect(() => {
        const fetchQueueData = async () => {
            const data = await getQueueDataForActivation(orgId, activationId);
            if (data) {
                setQueueData(data);
            }
        };

        const fetchPrintRollup = async () => {
            const rollup = await getPrintRollupForActivation(
                orgId,
                activationId,
            );
            if (rollup) {
                setPrintRollup(rollup);
            }
        };

        fetchQueueData();
        fetchPrintRollup();

        let timer = setInterval(() => {
            fetchQueueData();
            fetchPrintRollup();
        }, 10000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activationId]);

    const printsByDevice = new Map<string, number>(
        printRollup.devices.map((d) => [d.deviceKeyId, d.prints]),
    );

    return {
        queueData,
        printRollup,
        printsByDevice,
        isLoading,
        error,
    };
}
